import React, { Fragment } from 'react';
import { Button } from 'antd';
import clsx from 'clsx';
import { AnyCriteria } from '../../types/AlertConfiguration';
import { CriteriaError, ValidationError } from '../AlertCriteria';
import { BlockOr } from '../BlockOr';
import { Icons } from 'src/components/common/icons';

import styles from './BlockAnd.module.less';

type Props = {
  group: AnyCriteria[];
  errors?: Array<CriteriaError | null>;
  indexAnd: number;
  onAddOr: () => void;
  onRemoveOr: (iAnd: number, iOr: number) => void;
  onCriteriaChange: (iOr: number, criteria: AnyCriteria, error: ValidationError | null) => void;
  onCriteriaPaste: (indexAnd: number, indexOr: number) => void;
  onCriteriaCopy: (criteria: AnyCriteria) => void;
  isCopiedCriteria: boolean;
  setCopiedError: (error: CriteriaError | null) => void;
};

const ButtonGroup = Button.Group;

export const BlockAnd: React.FC<Props> = ({
  group,
  errors,
  indexAnd,
  onAddOr,
  onRemoveOr,
  onCriteriaChange,
  onCriteriaPaste,
  onCriteriaCopy,
  isCopiedCriteria,
  setCopiedError,
}) => {
  return (
    <div className={styles.root}>
      {indexAnd > 0 && (
        <div className={clsx(styles.separateLineAnd, styles.xRow)}>
          <p className={styles.title}>AND</p>
          <div className={styles.line} />
        </div>
      )}
      <div className={clsx(styles.blockAnd, 'box')}>
        {group.map((criteria, i) => {
          const isLineVisible = group.length > 1 && i < group.length - 1;
          const isOrVisible = i < group.length - 1;
          return (
            <Fragment key={i}>
              <BlockOr
                criteria={criteria}
                error={errors?.[i]}
                indexOr={i}
                onRemove={() => onRemoveOr(indexAnd, i)}
                onCriteriaChange={(criteria, error) => onCriteriaChange(i, criteria, error)}
                onCriteriaCopy={onCriteriaCopy}
                isOrVisible={isOrVisible}
                setCopiedError={setCopiedError}
                onCriteriaPaste={onCriteriaPaste}
                indexAnd={indexAnd}
                isCopiedCriteria={isCopiedCriteria}
              />
              {isLineVisible && <div className={styles.line} />}
            </Fragment>
          );
        })}
        <div className={styles.footer}>
          <div className={styles.xRow}>
            <Button
              type="primary"
              disabled={false}
              className={clsx(styles.buttonOr, styles.sizesButton)}
              onClick={onAddOr}
            >
              <Icons.Branch className={styles.iconBranch} />
              OR
            </Button>
          </div>
          {group.length > 0 && (
            <ButtonGroup className={styles.xRow}>
              <Button
                className={clsx(styles.btnCopyPast, styles.rightLine)}
                title="Copy"
                onClick={() => {
                  onCriteriaCopy(group[group.length - 1]);
                  setCopiedError(errors?.[group.length - 1] || null);
                }}
              >
                <Icons.Copy className={styles.iconPaste} />
              </Button>
              <Button
                disabled={!isCopiedCriteria}
                className={styles.btnCopyPast}
                title="Paste"
                onClick={() => onCriteriaPaste(indexAnd, group.length - 1)}
              >
                <Icons.Paste className={styles.iconPaste} />
              </Button>
            </ButtonGroup>
          )}
        </div>
      </div>
    </div>
  );
};
